
export default function ProblemSection() {
  const problems = [
    {
      icon: 'ri-folder-3-line',
      title: 'Scattered Portfolio',
      description: 'Your best work is buried across Canva, Instagram, Pinterest, Google Drive, and old PDFs. Clients can\'t find it. You can\'t showcase it.'
    },
    {
      icon: 'ri-time-line',
      title: 'Wasted Hours',
      description: 'Manually updating Websites, Instagram, Pinterest, PDFs, powerpoints, and answering repetitive questions drains your creative energy.'
    },
    {
      icon: 'ri-eye-off-line',
      title: 'Invisible Online',
      description: 'No professional presence means losing projects to professionals with polished portfolios.'
    }
  ];

  return (
    <section className="py-12 sm:py-16 lg:py-24 bg-[#F8F9FA] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        {/* Centered "The Problem" pill */}
        <div className="text-center mb-8 sm:mb-12">
          <div className="inline-block px-3 sm:px-4 py-2 bg-[#35C5F0]/10 border border-[#35C5F0]/30 rounded-full text-[#35C5F0] text-xs sm:text-sm font-semibold">
            The Problem
          </div>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-stretch">
          {/* Left - Image */}
          <div className="relative order-2 lg:order-1 flex">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl w-full h-full">
              <img
                src="https://public.readdy.ai/ai/img_res/6a5662a1171bbdf6c2aaa5994a6fdf98.jpg"
                alt="Frustrated Designer"
                className="w-full h-full object-cover object-top"
              />
              {/* Overlay gradient */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#2F3438]/80 via-transparent to-transparent"></div>
              
              {/* Floating problem indicators */}
              <div className="absolute top-3 right-3 sm:top-6 sm:right-6 bg-white rounded-lg p-2 sm:p-3 shadow-xl">
                <div className="flex items-center gap-2">
                  <i className="ri-error-warning-fill text-red-500 text-lg sm:text-xl"></i>
                  <div>
                    <div className="text-[10px] sm:text-xs text-[#ABB2B9]">Portfolio Status</div>
                    <div className="text-xs sm:text-sm font-semibold text-[#2F3438]">Scattered</div>
                  </div>
                </div>
              </div>

              <div className="absolute bottom-3 left-3 sm:bottom-6 sm:left-6 bg-white rounded-lg p-2 sm:p-3 shadow-xl">
                <div className="flex items-center gap-2">
                  <i className="ri-time-fill text-orange-500 text-lg sm:text-xl"></i>
                  <div>
                    <div className="text-[10px] sm:text-xs text-[#ABB2B9]">Time Wasted</div>
                    <div className="text-xs sm:text-sm font-semibold text-[#2F3438]">15hrs/week</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Glow effect */}
            <div className="absolute -inset-4 bg-[#35C5F0]/5 blur-3xl -z-10"></div>
          </div>

          {/* Right - Content */}
          <div className="order-1 lg:order-2 flex flex-col justify-center">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-[#2F3438] mb-4 sm:mb-6 leading-tight">
              Your creativity is drained by portfolio chaos
            </h2>
            
            <p className="text-base sm:text-lg lg:text-xl text-[#ABB2B9] mb-8 sm:mb-10 leading-relaxed">
              You're talented. Your work is stunning. But your portfolio is a mess, and you are losing opportunities.
            </p>

            <div className="space-y-4 sm:space-y-5">
              {problems.map((problem, index) => (
                <div 
                  key={index}
                  className="bg-white border border-[#ABB2B9]/20 rounded-xl p-4 sm:p-5 hover:shadow-lg hover:border-[#35C5F0]/30 transition-all group"
                >
                  <div className="flex items-start gap-3 sm:gap-4">
                    <div className="w-10 h-10 sm:w-11 sm:h-11 bg-[#35C5F0]/10 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-[#35C5F0]/20 transition-all">
                      <i className={`${problem.icon} text-xl sm:text-2xl text-[#35C5F0]`}></i>
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="text-base sm:text-lg font-semibold text-[#2F3438] mb-1">{problem.title}</h3>
                      <p className="text-sm text-[#ABB2B9] leading-relaxed">{problem.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
